import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const useCategories = () => {
    const queryClient = useQueryClient();

    const categoryQuery = useQuery({
        queryKey: ["categories"],
        queryFn: async () => {
            const response = await apiClient.get("/category");
            return response?.data?.data || [];
        },
    });

    const createMutation = useMutation({
        mutationFn: (data) => apiClient.post("/category", data),
        onSuccess: () => {
            toast.success("Category created successfully");
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Create failed"),
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => apiClient.put(`/category/${id}`, data),
        onSuccess: () => {
            toast.success("Category updated successfully");
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Update failed"),
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => apiClient.delete(`/category/${id}`),
        onSuccess: () => {
            toast.success("Category deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Delete failed"),
    });

    return {
        categories: categoryQuery.data || [],
        isLoading: categoryQuery.isLoading,
        isError: categoryQuery.isError,
        error: categoryQuery.error,
        createCategory: createMutation.mutateAsync,
        updateCategory: updateMutation.mutateAsync,
        deleteCategory: deleteMutation.mutateAsync,
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending,
    };
};